const RICH_CONTENT_CLASSES =
  '[&_a]:text-[#1A87CC] [&_b]:font-bold [&_em]:italic [&_h1]:mb-4 [&_h1]:text-2xl [&_h1]:font-bold [&_h1]:text-[#146599] [&_h2]:mb-3 [&_h2]:mt-6 [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-[#146599] [&_i]:italic [&_li]:mb-2 [&_ol]:my-4 [&_ol]:list-decimal [&_ol]:pl-6 [&_p]:mb-4 [&_strong]:font-bold [&_ul]:my-4 [&_ul]:list-disc [&_ul]:pl-6';

function RichContent({ content, className = '' }) {
  if (!content) return null;

  const isHtml = /<[a-z][\s\S]*>/i.test(content);

  if (isHtml) {
    return (
      <div
        className={`rich-content text-sm leading-[1.75] text-[#666666] sm:text-[15px] ${RICH_CONTENT_CLASSES} ${className}`.trim()}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  const paragraphs = content.includes('\n\n')
    ? content.split('\n\n').filter(Boolean)
    : [content];

  return (
    <div className={`space-y-4 text-sm leading-[1.75] text-[#666666] sm:text-[15px] ${className}`.trim()}>
      {paragraphs.map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
      ))}
    </div>
  );
}

export default RichContent;
